import { useTranslation } from 'react-i18next'

import { PanelContainer } from '../../../../components/Panel'
import { TrialTemplate } from '../../data'
import GenerateBoButton from './GenerateBoButton'
import TemplateDescription from './TemplateDescription'
import TemplateDropdown from './TemplateDropdown'

type GenerateboProps = {
  selectedTemplate?: TrialTemplate
  onSelectedTemplateChanged: (template: TrialTemplate) => void
  onRequestGenerateBo: () => Promise<void>
  isRequestRunning: boolean
  canGenerate: boolean
}

const Generatebo: React.FC<GenerateboProps> = ({
  selectedTemplate,
  onRequestGenerateBo,
  onSelectedTemplateChanged,
  canGenerate,
  isRequestRunning,
}) => {
  const { t } = useTranslation()

  return (
    <PanelContainer
      id="trial_generatebo"
      header={t('trial.generatebo.title')}
      toggleable={false}
    >
      <div className="grid">
        <div className="col-12 lg:col-4">
          <p>{t('trial.generatebo.information')}</p>
        </div>
        <div className="col-12 lg:col-7 lg:col-offset-1">
          <div className="grid">
            {/* Id */}
            <div className="col-12 flex flex-column">
              <label className="text-sm block mb-2" htmlFor="template">
                {t('trial.generatebo.labels.templates')}
              </label>
              <div className="my-2">
                <TemplateDropdown
                  selectedTemplate={selectedTemplate}
                  onSelectedTemplateChanged={onSelectedTemplateChanged}
                  isRequestRunning={isRequestRunning}
                />
              </div>
              <div>
                <TemplateDescription selectedTemplate={selectedTemplate} />
              </div>
            </div>

            <div className="col-12 my-2">
              <GenerateBoButton
                onRequestGenerateBo={onRequestGenerateBo}
                isRequestRunning={isRequestRunning}
                canGenerate={canGenerate}
              />
            </div>
          </div>
        </div>
      </div>
    </PanelContainer>
  )
}

export default Generatebo
